import { CaratteristichePadreNode } from '@gql/graphql'
import { WContainer } from '@components/atoms'
import { GridCertificationCard } from '@components/molecules'
import styles from './CertificationGrid.module.sass'

interface Props {
  className?: string
  certificazioni: CaratteristichePadreNode[]
}

const CertificationGrid = (props: Props) => {
  const { certificazioni = [], className = '' } = props

  return certificazioni?.length ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
        <div className={styles.layout}>
          {certificazioni.map((c) => (
            <GridCertificationCard key={c.id} certificazione={c} />
          ))}
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default CertificationGrid
